import { CircularProgress } from '@material-ui/core';
import React from 'react';
import { LOAD_TIME_OUT } from 'src/common/helpers/config';
import { canScannerScan, disableScanner, enableScanner } from 'src/devices/scanner-operations';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from '../../emerald-modal-manager/emerald-modal-manager';
import EmeraldModal from '../emerald-modal/emerald-modal';
import { styles } from './with-spinner-styles';

let timeout: NodeJS.Timeout;
export const SPINNER_ID = 'with-spinner-loading-spinner';
let withSpinCount = 0;
let isSpinning = false;

let isScannerEnabledBeforeSpin: boolean;

export const LoadingSpinnerModal = (): JSX.Element => {
  const classes = styles();
  return (
    <EmeraldModal open data-testid='spinner-modal' className={classes.modal}>
      <CircularProgress className={classes.spinner} />
    </EmeraldModal>
  );
};

// TODO remove showLoadingComponent from request.  Use only resume / pause spinner
// Only use withspiiner for the sipnner of a promise flow
export const startRequestSpinner = (showLoadingComponent?: boolean): void => {
  showLoadingComponent && startSpinner();
};

export const stopRequestSpinner = (
  showLoadingComponent: boolean,
  onRequestError: boolean,
): void => {
  showLoadingComponent && endSpinner(onRequestError);
};

// Spinner function dealing with scanner
// Internal spinner handling only
// Please use withSpinner for all common BL
const startSpinner = (): void => {
  if (!withSpinCount++) {
    isScannerEnabledBeforeSpin = canScannerScan();
  }
  resumeWithSpinner();
};

// Spinner function dealing with scanner
// Internal spinner handling only
// Please use withSpinner for all common BL
// Close spinner for any request error which stops the flow
const endSpinner = (onRequestError: boolean = false): void => {
  if (withSpinCount === 1 || onRequestError) {
    pauseWithSpinner();
  }
  withSpinCount--;
};

// Internal spinner handling only
// Please use withSpinner for all common BL
export const resumeWithSpinner = async (): Promise<void> => {
  if (!withSpinCount || isSpinning) {
    return;
  }
  if (canScannerScan()) {
    disableScanner();
  }
  isSpinning = true;
  clearTimeout(timeout);
  if (LOAD_TIME_OUT === 0) {
    pushEmeraldModal(<LoadingSpinnerModal />, undefined, SPINNER_ID);
  } else {
    timeout = setTimeout(
      () => pushEmeraldModal(<LoadingSpinnerModal />, undefined, SPINNER_ID),
      LOAD_TIME_OUT,
    );
  }
};

// Internal spinner handling only
// Please use withSpinner for all common BL
export const pauseWithSpinner = (): void => {
  if (!withSpinCount || !isSpinning) {
    return;
  }
  if (isScannerEnabledBeforeSpin) {
    enableScanner();
  }
  isSpinning = false;
  clearTimeout(timeout);
  popEmeraldModal(SPINNER_ID);
};

export const withSpinner = async <T extends unknown>(
  wrappedFunction: () => Promise<T>,
): Promise<T> => {
  startSpinner();
  return wrappedFunction().finally(endSpinner);
};
